import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { SelectSingleComponent } from './select-single.component';

@NgModule({
    declarations: [
        SelectSingleComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        SelectSingleComponent
    ]
})

/**
 * Module for SelectSingleCheckbox component
 */
export class SelectSingleModule { }
